import type { RouteRecordRaw } from 'vue-router'

const PlaceholderView = () => import('./PlaceholderView.vue')

// One placeholder per page that is not built yet. Each page's own ticket replaces its
// entry with a real feature route.
export const routes: RouteRecordRaw[] = [
  {
    path: '/performance',
    name: 'performance',
    component: PlaceholderView,
    // Performance has its own view of all engines, so the header shows no selector.
    meta: { title: 'Performance', hideEngineSelector: true },
  },
  {
    path: '/review',
    name: 'review',
    component: PlaceholderView,
    meta: { title: 'Review & Approve', engineScoped: true },
  },
  {
    path: '/pause',
    name: 'pause',
    component: PlaceholderView,
    meta: { title: 'Pause', engineScoped: true },
  },
  {
    path: '/audit',
    name: 'audit',
    component: PlaceholderView,
    meta: { title: 'Audit', engineScoped: true },
  },
]
